import { Subject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { TwentyOne } from 'game-logic';
import { ColumnStackViewModel } from './column-stack-view-model';
import { ScoreLabelViewModel } from '../components/score-label-view-model';
import { TwentyOneAssetType, TwentyOneStylesType } from '../../model/twentyone-types';

export class ColumnViewModel {
  public get scoreBoxAsset() {
    return this.gameServices.assetCatalogueService.getAsset(TwentyOneAssetType.ScoreBox);
  }
  public get columnBoxAsset() {
    return this.gameServices.assetCatalogueService.getAsset(TwentyOneAssetType.ColumnBox);
  }
  public get wildSparkleAsset() {
    return this.gameServices.assetCatalogueService.getAsset(TwentyOneAssetType.WildSparkle);
  }
  public get bonusFillColor() {
    return this.gameServices.gameThemeService.getHexColor(TwentyOneStylesType.BonusLabelFill);
  }
  public get bonusOutlineColor() {
    return this.gameServices.gameThemeService.getHexColor(TwentyOneStylesType.BonusLabelOutline);
  }
  public get wildSymbolColor() {
    return this.gameServices.gameThemeService.getNumericalRGB(TwentyOneStylesType.WildSymbolColor);
  }
  public get wildSymbolAlpha() {
    return this.gameServices.gameThemeService.getNumericalAlpha(
      TwentyOneStylesType.WildSymbolColor,
    );
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get onGameSetupStart$() {
    return this.gameServices.twentyOneGameRunner.onGameSetupStart$;
  }
  public get onGameSetupComplete$() {
    return this.gameServices.twentyOneGameRunner.onGameSetupComplete$;
  }
  public get logicEventQueue$() {
    return this.gameServices.twentyOneGameRunner.logicEventQueue$;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get columnIndex() {
    const i = this.columnId as number;
    return i <= 2 ? i - 3 : i - 3;
  }

  private readonly onResetGameScene = new Subject<void>();
  public readonly columnStackViewModel: ColumnStackViewModel;
  public readonly hintLabelViewModel: ScoreLabelViewModel;
  public readonly scoreLabelViewModel: ScoreLabelViewModel;

  constructor(
    private gameServices: GameServices,
    public readonly columnId: TwentyOne.PileId,
  ) {
    this.columnStackViewModel = new ColumnStackViewModel(gameServices, columnId);
    this.hintLabelViewModel = new ScoreLabelViewModel(
      gameServices,
      TwentyOneStylesType.HintLabelFill,
    );
    this.scoreLabelViewModel = new ScoreLabelViewModel(
      gameServices,
      TwentyOneStylesType.ScoreLabelFill,
    );
  }

  public resetGameScene(): void {
    this.columnStackViewModel.resetGameScene();
    this.hintLabelViewModel.setScore('', false);
    this.scoreLabelViewModel.setScore('', false);

    this.onResetGameScene.next();
  }

  public updateHint(text: string, instant: boolean) {
    this.hintLabelViewModel.setScore(text, instant);
  }

  public updateScore(text: string, instant: boolean) {
    this.scoreLabelViewModel.setScore(text, instant);
  }
}
